<template>
<div class="order-wrapper payment-wrapper" v-bind:class="{ 'is-active': openSlideleft }">
  <portal target-el="#filter">
    <PrimaryFilter
      :searchText="$t('SEARCH')"
      :selectedCategory="selectedCategory"
      :menuOptions="$checkMenuOptions(Menu)"
      :buttonsList="walletButtons"
      :enableSearchPopup="enableSearchPopup"
      :searchParameters="walletSearchParameters"
      :preSearchedParams="searchedParams"
      @searchByParameter="searchByParameter"
      @exportWallet="exportWallet" />
  </portal>
  <div>
    <div class="flex-container page-filter">
      <div class="flex-item">
        <FilterWrapper
          :values="filterTags"
          @openSliderLeft="openSlideleft = !openSlideleft">
        </FilterWrapper>
      </div>

      <div class="col-md-auto" v-if="walletTotal">
        <div class="selectedcount">
          <div>
            <span class="selectedcount-name">{{ $t('WALLET_TOTAL') }}</span>
          </div>
          <div class="selectedcount-errorvalue">
            <svgicon name="rupee-error" class="icon" width="12" height="12" :original="true" />
            {{$getIndianFormat(walletTotal)}}
          </div>
        </div>
      </div>
    </div>
    <div class="slideleft_drawer" :class="{ openSlideleft: openSlideleft }">
      <div class="slideleft_content"
        v-infinite-scroll="loadData"
        infinite-scroll-disabled="loadCheck"
        infinite-scroll-throttle-delay="400"
        infinite-scroll-distance="10">
        <div class="content">
          <div class="cardpanel alertoption">
            <Header :headers="WalletHeader"
              :noCheckbox="noCheckBox" />
            <div v-if="isLoading" class="paymentloader"></div>
            <div v-else-if="list.length === 0" class="emptydiv">
              <div class="paymentempty"></div>
              <div class="emptytext">Enjoy your day, no wallet entries!</div>
            </div>
            <div v-else>
              <Row v-for="(wallet,index) in list"
                :sectionHeader="WalletHeader"
                :wallet="wallet"
                :key="index"
                :walletConfig="currentClientConfig && currentClientConfig.wallet"
                @getConsigneeDetails="showDetails"
                @elDraweropen="showDetails" />
            </div>
          </div>
        </div>
      </div>
      <div class="slideleft_menu">
        <SecFilter
          :selectedFilters="filterConstant"
          :filters="WalletFilters"
          v-on:updateOption="updateOption"
          v-on:search="search"
          v-on:reset="resetApply"/>
      </div>
      <div class="slideleft_drawer">
        <div class="slideleft_content">
          <div class="content pt-20">
            <Drawer
              :visible.sync="elDraweropen"
              direction="rtl"
              size="500px"
              :modal="true"
              :withHeader="false"
              :append-to-body="true"
              :destroy-on-close="true"
              class="default-drawer">
              <Link :underline="false" class="nav-close" @click="elDraweropen = false">
                  <svgicon name="cancelwhite" width="12" height="12" :original="true" />
              </Link>
              <div class="drawer-body p-0">
                <WalletDetails
                v-if="elDraweropen"
                :key="selectedWallet.id"
                :wallet="selectedWallet"
                :remarks="walletRemarks"
                :timelines="walletTimeline"
                :activeTab="showDetailsDrawer"
                @updateAmount="updateWallet"
                @addAttachments="addAttachments"
                @removeAttachments="removeAttachments"
                :walletConfig="currentClientConfig && currentClientConfig.wallet" />
              </div>
            </Drawer>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import PrimaryFilter from '@/components/common/PrimaryFilter';
import FilterWrapper from '@common/components/FilterWrapperV2';
import SecFilter from '@common/components/SecFilter';
import SecFilterMixin from '@common/mixins/SecFilterMixin';
import Header from '@common/components/Header';
import Details from '@common/components/WalletDetails';
import { WalletHeader, Menu, WalletButtons, WalletFilters, walletSearchParameters } from '@/constants/payments';
import Row from '../../wallet-v2/Row';
import WalletDetails from '../../wallet-v2/WalletDetails';
import { WalletReasonList, WalletStatusList, attachmentParentType } from 'pando-constants';
import downloadFile from '@common/utils/downloadFile';
import moment from 'moment';

export default {
  components: {
    Header,
    Row,
    PrimaryFilter,
    FilterWrapper,
    SecFilter,
    Details,
    WalletDetails,
  },
  mixins: [SecFilterMixin],
  data() {
    return {
      Menu,
      WalletButtons,
      enableSearchPopup: true,
      WalletHeader,
      WalletReasonList,
      WalletStatusList,
      WalletFilters,
      noCheckBox: true,
      openSlideleft: false,
      defaultValues: {},
      loadCheck: true,
      filterConstant: [],
      clientName: null,
      walletTotal: null,
      isOpenDetails: false,
      selectedWallet: {},
      elDraweropen: false,
      walletSearchParameters,
      searchedParams: {},
      allDepots: {
        name: 'All Depots',
        id: -1,
      },
      depots: null,
      walletTimeline: [],
      walletRemarks: [],
      showDetailsDrawer: 'REMARKS',
    };
  },
  computed: {
    ...mapGetters({
      clients: 'app/clients',
      list: 'walletV2/list',
      filter: 'walletV2/filter',
      hasEmpty: 'walletV2/hasEmpty',
      isLoading: 'walletV2/isLoading',
      depotsList: 'app/depots',
      currentClientConfig: 'app/currentClientConfig',
      otherDepots: 'app/getOtherDepots',
    }),
    selectedCategory() {
      return this.Menu.find(menu => menu.id === 'Wallet-v2');
    },
    walletStatusOptions() {
      return this.WalletStatusList.filter(wallet => !wallet.isTransporterDisabled).map(status => ({
        name: status.label,
        id: status.id,
      }));
    },
    depotDefaultOptions() {
      const noDepotFilter = { name: '' };
      const depotLengthNumOrFlag = ((Array.isArray(this.depotsList) && this.depotsList.length))
      || (Array.isArray(this.otherDepots) && this.otherDepots.length);
      const defaultValue = depotLengthNumOrFlag > 0 ?
        (this.depotsList[0] || this.otherDepots[0]) : noDepotFilter;
      return defaultValue;
    },
    walletButtons() {
      return this.WalletButtons.map((button) => {
        if (button.id === 1) {
          return { ...button, disabled: this.list.length === 0 };
        }
        return button;
      });
    },
  },
  async created() {
    this.setDefaults();
    this.$store.commit('walletV2/initialReset');
    this.loadFilters();
    this.loadSearchFromSession();
    this.search();
  },
  methods: {
    loadSearchFromSession() {
      const sessionSearchParamsJSON = localStorage.getItem(`${this.$route.name}-search-popup`) || '{}';
      const sessionSearchParams = JSON.parse(sessionSearchParamsJSON);
      this.searchedParams = Object.assign({}, this.searchedParams, sessionSearchParams);
    },
    saveSearchToSession() {
      const sessionSearch = JSON.stringify(this.searchedParams);
      localStorage.setItem(`${this.$route.name}-search-popup`, sessionSearch);
    },
    async updateWallet(payload) {
      const result = await this.$store.dispatch('walletV2/update', payload);
      if (result && result.error) {
        this.$errorMessage({ message: result.error });
      } else {
        this.$successMessage({ message: 'Waller Disputed Successfully' });
        this.elDraweropen = false;
      }
    },
    async showDetails(walletId, activeTab) {
      try {
        const [walletResult, timelineRemarksResult] = await Promise.all([
          this.$store.dispatch('walletV2/show', walletId),
          this.$store.dispatch('walletV2/getWalletTimelineAndRemarks', { walletId }),
        ]);
        
        if (walletResult && walletResult.error) {
          this.$errorMessage({ message: walletResult.error });
        } else if (walletResult) {
          this.selectedWallet = walletResult;
          this.walletTimeline = (timelineRemarksResult && timelineRemarksResult.data && timelineRemarksResult.data.timeline) || [];
          const remarks = (timelineRemarksResult && timelineRemarksResult.data && timelineRemarksResult.data.remarks) || [];
          this.walletRemarks = remarks.map(remark => ({ ...remark, timestamp: remark.created_at }));
          this.showDetailsDrawer = activeTab;
          this.elDraweropen = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async addAttachments(file, attachmentDetails) {
      const formData = new FormData();
      formData.append('attachment', file.raw);
      formData.append('parent_id', attachmentDetails.parent_id);
      formData.append('parent_type', attachmentDetails.parent_type);
      const result = await this.$store.dispatch('walletV2/addAttachment', formData);
      if (result && result.error) {
        this.$errorMessage({ message: result.error });
      } else if (result && result.data) {
        const attachment = result.data;
        this.selectedWallet.attachments.push({
          name: attachment.content_file_name,
          url: attachment.metadata.location,
          id: attachment.id,
        });
      }
    },
    async removeAttachments(file) {
      const result = await this.$store.dispatch('walletV2/deleteAttachment', { attachmentId: file.id });
      if (result && result.error) {
        this.$errorMessage({ message: result.error });
      } else {
        this.selectedWallet.attachments = this.selectedWallet.attachments.filter(
          attachment => attachment.id !== file.id);
      }
    },
    setDefaults() {
      this.defaultValues.depots = [this.depotDefaultOptions];
      [this.defaultValues.client] = this.clients;
      this.defaultValues.reason = this.WalletReasonList;
      this.defaultValues.status = this.WalletStatusList.filter(wallet => !wallet.isTransporterDisabled);
      this.defaultValues.endDate = moment().toString();
      this.defaultValues.startDate = moment().subtract(3, 'months').toString();
    },
    constructConstantForFilter() {
      this.depots = this.depotsList;
      const depotList = this.constructDepotGroup(this.depotsList, this.otherDepots,
        this.defaultValues.depots.map(depot => depot.id));
      this.filterConstant = [
        [
          {
            type: 'MultiSelectGroup',
            category: this.WalletFilters.DEPOT,
            default: this.defaultValues.depots,
            selected: this.defaultValues.depots,
            list: depotList,
            idLabel: 'id',
            optional: false,
            selectAllOption: true,
            allowEmpty: false,
            search: true,
            queryParamString: 'depot_id',
            placeholder: 'Select depots',
            tlabel: 'WALLET_DEPOT',
          },
          {
            type: 'Date',
            category: this.WalletFilters.DATE,
            defaultStartDate: this.defaultValues.startDate,
            defaultEndDate: this.defaultValues.endDate,
            startDate: this.defaultValues.startDate,
            endDate: this.defaultValues.endDate,
            start_date_label: 'start_date',
            end_date_label: 'end_date',
            optional: false,
            tlabel: 'WALLET_DATE',
          },
        ],
        [
          {
            type: 'List',
            category: this.WalletFilters.CLIENT,
            default: this.defaultValues.client,
            selected: this.defaultValues.client,
            list: this.clients,
            idLabel: 'id',
            optional: false,
            search: true,
            queryParamString: 'client_id',
            placeholder: 'Select client',
            tlabel: 'WALLET_CLIENT',
          },
          {
            type: 'MultiSelectList',
            category: this.WalletFilters.STATUS,
            default: this.defaultValues.status,
            selected: this.defaultValues.status,
            list: this.walletStatusOptions,
            idLabel: 'id',
            optional: false,
            defaultSelectAll: true,
            allowEmpty: false,
            queryParamString: 'status',
            placeholder: 'Select status',
            tlabel: 'WALLET_STATUS',
          },
          {
            type: 'MultiSelectList',
            category: this.WalletFilters.REASON,
            default: this.defaultValues.reason,
            selected: this.defaultValues.reason,
            list: this.WalletReasonList,
            idLabel: 'id',
            optional: false,
            selectAllOption: true,
            defaultSelectAll: true,
            allowEmpty: true,
            queryParamString: 'reason',
            placeholder: 'Select reason',
            tlabel: 'WALLET_REASON',
          },
        ],
      ];
    },
    resetApply() {
      this.$store.commit('walletV2/SET_PAGE', 1);
      this.resetAll();
      this.search();
    },
    searchByParameter(params) {
      this.searchedParams = params;
      this.$store.commit('walletV2/SET_PAGE', 1);
      this.saveSearchToSession();
      this.loadData();
    },
    search() {
      this.$store.commit('walletV2/SET_PAGE', 1);
      this.applyFilters();
      this.openSlideleft = false;
      this.loadData();
    },
    async loadData() {
      let filter = this.constructFilterPayload();
      try {
        if (filter && (this.depotsList.length > 0 || this.otherDepots.length)) {
          filter = Object.assign(filter, this.filter);
          if (filter.depot_id) {
            filter.location_id = filter.depot_id;
          }
          delete filter.depot_id;
          if (this.clientName) {
            filter.client = this.clientName;
          }
          this.searchedParams = Object.fromEntries(Object.entries(this.searchedParams).filter(([_, v]) => v !== null));
          if (this.searchedParams && Object.keys(this.searchedParams).length) {
            Object.assign(filter, { ...this.searchedParams });
          }
          const result = await this.$store.dispatch('walletV2/filter', { params: filter });
          if (result && result.error) {
            this.$errorMessage({ message: result.error });
          }
          if (result.meta) {
            this.walletTotal = result.meta.total_amount;
          }
          this.loadCheck = this.hasEmpty;
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('LISTING_FAILS') });
      }
    },
    searchByClient(query) {
      this.clientName = query;
      this.$store.commit('walletV2/SET_PAGE', 1);
      this.loadData();
    },
    async exportWallet() {
      try {
        const filter = this.constructFilterPayload();
        if (filter) {
          if (filter.depot_id) {
            filter.location_id = filter.depot_id;
          }
          delete filter.depot_id;
          const result = await this.$store.dispatch('walletV2/export', { params: filter });
          if (result.type === 'application/json') {
            this.$successMessage({
              message: this.$getSuccess('EXPORT_VIA_EMAIL'),
            });
          } else if (result) {
            const url = window.URL.createObjectURL(new Blob([result]));
            const now = new Date().toISOString();
            downloadFile(document, url, `wallet-${now}.xlsx`);
          }
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('EXPORT_FAILS') });
      }
    },
  },
};
</script>

<style lang="scss">

</style>
